import { useOutsideClick as chakraUseOutsideClick } from '@chakra-ui/react';
import { REDO_BUTTON_ID, UNDO_BUTTON_ID } from 'constants/editor';
import { RefObject } from 'react';

type UseOutsideClick = {
  ref: RefObject<HTMLElement>;
  // function to be called when click outside the ref element
  handler: () => void;
  // if the click path has element with this id will not trigger the handler
  ignoreId?: string | string[];
  // clicking undo/redo will not trigger the handler
  allowUndoRedo?: boolean;
};

const undoRedoIds = [UNDO_BUTTON_ID, REDO_BUTTON_ID];

/**
 * The base Chakra useOutsideClick with extended functionality
 * optionally ignore clicks on elements with a specific id
 * optionally ignore clicks on undo/redo buttons
 *
 */
export const useOutsideClick = ({ ref, handler, ignoreId, allowUndoRedo = true }: UseOutsideClick) => {
  const onClickOutside = (e: Event) => {
    const path = e.composedPath();

    for (let i = 0; i < path.length; i++) {
      const el = path[i] as Element;
      const id = el?.id;

      if (ignoreId && id === ignoreId) return;
      if (Array.isArray(ignoreId) && ignoreId.includes(id)) return;
      if (allowUndoRedo && undoRedoIds.includes(id)) return;
    }

    handler();
  };

  chakraUseOutsideClick({ ref, handler: onClickOutside });
};
